import { ChainId } from './chainId';

export default {
  multiTransfer: {
    [ChainId.Mainnet]: '0xB6d6E96e1B8D5eB82959302d7E60B62D40c892c5',
    [ChainId.BSC]: '0x6379082dA2C77D1A2f17B7947cE074416071879a',
    [ChainId.Rinkeby]: '0xffA1578B4774342D557104dd4A9C543DD923691e',
    [ChainId.BSCTestnet]: '0xDa3e46125B9a21a835b012dCa0B4a3EFEB3bE31B',
  },
};
